import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TargetAcheivedStars from "../../components/TargetAcheivedStars";
import { useTranslation } from "react-i18next";
import './styles.css';
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import StackedHorizontalBar from "../../components/Charts/StackedHorizontalBar";
import { colors } from "../../common/pallette/colors";
import StatusIndicatorSmall from "../../components/StatusIndicatorSmall";
import { genUID, getAverageSiteStatus } from "../../common/StaticExports";
import ReportsStandardsTable from "../../components/ReportsStandardsTable";
import ReportsActionsTable from "../../components/ReportsActionsTable";
import { AvatarAndName } from "../../components/AvatarAndName";
import ButtonDefault from "../../components/ButtonDefault";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { TextAreaWithoutBorders } from "../../components/TextAreaWithoutBorders";
import { useSelector } from "react-redux";
import { draftData } from "../ReportEditor/staticReportData";
import { getCriteriaComments, saveCriteriaComments } from "../../api/evaluation";

const ReportsCriteriaDetails = (props:any) => {
    const { data, reportType } = props;
    const reportData = useSelector((state:any) => state.evaluation.reportData);
    const currentClub = useSelector((state:any) => state.clubDetails);
    // const reportData = draftData;
    const [t] = useTranslation();
    const siteReviewPalette = [
      colors.grey.dark,
      colors.statusColors.met,
      colors.statusColors.partial,
      colors.statusColors.notMet
    ];
    const [statusData, setStatusData] = useState([]);
    const [overallStatus, setOverallStatus] = useState();
    const [standardsStatusData, setStandardsStatusData] = useState([]);
    const [overallStandardsStatus, setOverallStandardsStatus] = useState();
    const [editorContent, setEditorContent] = useState("");
    const [criteriaComments, setCriteriaComments]:any = useState();
    const [addAction, setAddAction] = useState(false);
    
    const SyncPlugin = (props:any) => {
        const { content, setContent } = props;
        const [editor] = useLexicalComposerContext();
        
        // Sync Lexical content to React state
        useEffect(() => {
            return editor.registerUpdateListener(({ editorState }) => {
            editorState.read(() => {
                const text = $getRoot().getTextContent();
                setContent(text);
            });
            });
        }, [editor]);
        
        // Sync React state back to Lexical when content changes
        // useEffect(() => {
        //   editor.update(() => {
        //     const root = $getRoot();
        //     root.clear();
        //     root.append($createTextNode(content));
        //   });
        // }, [content, editor]);
        
        return null;
    };
    
    const fetchKey:any = (value:any) => {
        switch(value) {
            case 2:
                return 'interimReportComment';
            default:
                return 'finalReportComment';
        }
    }
    //managing criteria group status
    useEffect(() => {
        var notEval = 0;
        var met = 0;
        var partial = 0;
        var notMet = 0;
        const criterias = reportData?.Criteria?.filter((d:any) => d.CriteriaGroupId === data?.CriteriaGroupId);
        if(criterias?.length > 0) {
            var key = 'Status';
            const criteriaArr = criterias;
            criteriaArr.map((d:any) => {
            switch(d[key]){
                case 0:
                notEval++;
                break;
                case 1:
                notMet++;
                break;
                case 2:
                partial++;
                break;
                case 3:
                met++;
                break;
            }
            });
            const tempData:any = [
            {
                name: "NOT_EVALUATED",
                data: [notEval],
            },
            {
                name: "MET",
                data: [met],
            },
            {
                name: "PARTIAL",
                data: [partial]
            },
            {
                name: "NOT_MET",
                data: [notMet]
            }
            ];
            setStatusData(tempData);
        }
    }, [data]);

    useEffect(() => {
        const criterias = reportData?.Criteria?.filter((d:any) => d.CriteriaGroupId === data?.CriteriaGroupId);
        const criteriaStatuses = criterias.map((d:any) => d?.Status);
        const statusAvg:any = getAverageSiteStatus(criteriaStatuses);
        setOverallStatus(statusAvg);
        !criteriaComments &&
        fetchCriteriaComments();
    }, [data]);

    //managing criteria standards status
    useEffect(() => {
        var notEval = 0;
        var met = 0;
        var partial = 0;
        var notMet = 0;
        const standards = data?.Standards || [];
        if(standards?.length > 0) {
            var key = 'Status';
            const criteriaArr = standards;
            criteriaArr.map((d:any) => {
            switch(d[key]){
                case 0:
                notEval++;
                break;
                case 1:
                notMet++;
                break;
                case 2:
                partial++;
                break;
                case 3:
                met++;
                break;
            }
            });
            const tempData:any = [
            {
                name: "NOT_EVALUATED",
                data: [notEval],
            },
            {
                name: "MET",
                data: [met],
            },
            {
                name: "PARTIAL",
                data: [partial]
            },
            {
                name: "NOT_MET",
                data: [notMet]
            }
            ];
            setStandardsStatusData(tempData);
        }
    }, [data]);

    
    const fetchCriteriaComments = async () => {
        const response = await getCriteriaComments({ clubId: currentClub.id, criteriaId: data.Id});
        setCriteriaComments(response);
        setEditorContent(response?.interimReportComment);
    }
    useEffect(() => {
        const standardsStatuses = data?.Standards?.map((d:any) => d?.Status);
        const statusAvg:any = getAverageSiteStatus(standardsStatuses);
        setOverallStandardsStatus(statusAvg);
    }, [data]);

    const actions = data?.Standards?.flatMap((d:any) => d?.Actions);

    const updateComments = () => {
        saveCriteriaComments({id: criteriaComments?.id ? criteriaComments?.id : 0,
                data: {...criteriaComments, [fetchKey(reportType)]: editorContent,
                criteriaId: data?.Id, clubId: currentClub.id,
                }}).then((res:any) => {
                    setCriteriaComments(res);
                    setEditorContent(res?.interimReportComment);
                });
    }
    return (
        <Box className={'a4Spacing mb20'}>
            {/* commented criteria group header */}
            {/* <Box className={'rcdHeader'}>
                <Typography className="fw700 fs14 uppercase">{data?.CriteriaGroupName}</Typography>
                <Box className={'rcdStatusWrapper'}>
                    <Box className={'mr5'}>
                        <StackedHorizontalBar data={statusData} label={t('EVALUATION')+': '} colorPalette={siteReviewPalette} width={100} />
                    </Box>
                    <Box className={'reStatusWrapper'}>
                        <Typography className={"reStatusLabel"}>{t('STATUS')+': '}</Typography>
                    <StatusIndicatorSmall reportType={'siteReview'} status={overallStatus} />
                    </Box>
                </Box>
            </Box> */}
            <Box className={'rcdHeader'}>
                <Typography className="fw700 fs18 uppercase rcd">{genUID(data?.Uid) + ' ' +data?.Name}</Typography>
                <Box className={'rcdStatusWrapper'}>
                    <Box className={'mr5'}>
                        <StackedHorizontalBar data={standardsStatusData} label={t('EVALUATION')+': '} colorPalette={siteReviewPalette} width={100} />
                    </Box>
                    <Box className={'reStatusWrapper'}>
                        <Typography className={"reStatusLabel"}>{t('STATUS')+': '}</Typography>
                        <StatusIndicatorSmall reportType={'siteReview'} status={overallStandardsStatus}/>
                    </Box>
                </Box>
            </Box>
            <ReportsStandardsTable data={data?.Standards} />
            <Box className={'rcdcommentBoxWrapper'}>
                {/* <ContentEditable
                    className={'ContentEditable__criteriaComments'}
                /> */}
                <Box className={'criteriaCommentsrcd'}>
                    <TextAreaWithoutBorders value={editorContent} handleChange={(e:any) => {setEditorContent(e.target.value)}} manageOnBlur={updateComments}/>
                </Box>
                <Box className={'rcdcommentBoxWrapperRight'}>
                    <Box>
                        <AvatarAndName avatarName={'Adam.Test'} avatarImage={''}/>
                        <Typography className="fs12 textAlignLeft mt20 ml30">{'2024.11.12'}</Typography>
                    </Box>
                    {
                        true &&
                        <Box sx={{ float: "right", textAlign: "left" }}>
                            <ButtonDefault value={t('ADD_ACTION')} 
                            manageOnClick={() => {
                                setAddAction(true);
                            }}
                            icon={<FontAwesomeIcon icon={faCirclePlus} />}/>
                        </Box>
                    }
                </Box>
            </Box>
            {
                actions && actions.length > 0 &&
                <ReportsActionsTable data={actions} addAction={addAction} discardAddAction={() => {setAddAction(false)}} criteria={data}/>
            }
            {/* <SyncPlugin content={editorContent} setContent={setEditorContent} /> */}
        </Box>
    )
}

export default ReportsCriteriaDetails;